"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const NoRequests = createSvgIcon(
  <g id="Frame 3411">
    <path
      id="Subtract"
      d="M2.84753 22.756L9.40041 61.9227H40.3902C39.7255 60.7067 39.219 59.3919 38.8984 58.006H12.6467L7.65299 26.6726H59.353L57.3311 39.3591C58.6776 39.6541 59.9585 40.1241 61.1489 40.7441L64.1584 22.756H2.84753ZM41.3363 40.381H25.6697C25.1148 40.381 24.6497 40.1939 24.2743 39.8198C23.899 39.4457 23.7113 38.9809 23.7113 38.4253C23.7113 37.8696 23.899 37.4039 24.2743 37.028C24.6497 36.6522 25.1148 36.4643 25.6697 36.4643H41.3363C41.8912 36.4643 42.3563 36.6513 42.7316 37.0254C43.107 37.3995 43.2947 37.8644 43.2947 38.42C43.2947 38.9756 43.107 39.4413 42.7316 39.8172C42.3563 40.193 41.8912 40.381 41.3363 40.381ZM8.60768 16.7691C8.98302 17.1449 9.44813 17.3329 10.003 17.3329H57.003C57.5578 17.3329 58.023 17.1458 58.3983 16.7717C58.7736 16.3976 58.9613 15.9328 58.9613 15.3772C58.9613 14.8215 58.7736 14.3558 58.3983 13.98C58.023 13.6041 57.5578 13.4162 57.003 13.4162H10.003C9.44813 13.4162 8.98302 13.6033 8.60768 13.9774C8.23233 14.3514 8.04466 14.8162 8.04466 15.3719C8.04466 15.9275 8.23233 16.3932 8.60768 16.7691ZM16.441 7.42928C16.8164 7.80515 17.2815 7.99308 17.8363 7.99308H49.1697C49.7245 7.99308 50.1896 7.80603 50.565 7.43192C50.9403 7.05788 51.128 6.59304 51.128 6.0374C51.128 5.48182 50.9403 5.01609 50.565 4.64022C50.1896 4.26435 49.7245 4.07642 49.1697 4.07642H17.8363C17.2815 4.07642 16.8164 4.26347 16.441 4.63758C16.0657 5.01169 15.878 5.47653 15.878 6.03211C15.878 6.58775 16.0657 7.05348 16.441 7.42928Z"
    />
    <g id="cancel">
      <mask
        id="mask0_391_6027"
        maskUnits="userSpaceOnUse"
        x="40"
        y="40"
        width="29"
        height="29"
      >
        <rect
          id="Bounding box"
          x="40"
          y="40"
          width="28.1683"
          height="28.1683"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_391_6027)">
        <path
          id="cancel_2"
          d="M49.858 59.9526L54.0832 55.7274L58.3085 59.9526L59.9516 58.3094L55.7264 54.0842L59.9516 49.859L58.3085 48.2158L54.0832 52.4411L49.858 48.2158L48.2148 49.859L52.4401 54.0842L48.2148 58.3094L49.858 59.9526ZM54.0832 65.821C52.4596 65.821 50.9339 65.5129 49.5059 64.8967C48.0779 64.2805 46.8358 63.4443 45.7794 62.388C44.7231 61.3317 43.8869 60.0895 43.2707 58.6616C42.6545 57.2336 42.3464 55.7078 42.3464 54.0842C42.3464 52.4606 42.6545 50.9348 43.2707 49.5069C43.8869 48.0789 44.7231 46.8367 45.7794 45.7804C46.8358 44.7241 48.0779 43.8879 49.5059 43.2717C50.9339 42.6555 52.4596 42.3474 54.0832 42.3474C55.7068 42.3474 57.2326 42.6555 58.6606 43.2717C60.0886 43.8879 61.3307 44.7241 62.387 45.7804C63.4433 46.8367 64.2796 48.0789 64.8957 49.5069C65.5119 50.9348 65.82 52.4606 65.82 54.0842C65.82 55.7078 65.5119 57.2336 64.8957 58.6616C64.2796 60.0895 63.4433 61.3317 62.387 62.388C61.3307 63.4443 60.0886 64.2805 58.6606 64.8967C57.2326 65.5129 55.7068 65.821 54.0832 65.821Z"
        />
      </g>
    </g>
  </g>,
  "NoRequests",
)

const NoRequestsIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <NoRequests sx={{ fill: _fill, ...sx }} {...rest} />
}

export default NoRequestsIcon
